import { render, staticRenderFns } from "./product-itinerary.vue?vue&type=template&id=77d46dd1&"
import script from "./product-itinerary.vue?vue&type=script&lang=js&"
export * from "./product-itinerary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports